const html = `<h3 style="text-align: center;"><strong>ISTOTA CLOUD COMPUTINGU</strong></h3>
<p><span style="font-weight: 400;">Cloud computing to model przetwarzania danych wykorzystujący usługi dostarczane przez dostawcę (może to być zewnętrzna firma lub wewnętrzny dział IT). Gł&oacute;wnym założeniem jest wsp&oacute;łdzielenie zasob&oacute;w infrastrukturalnych oraz oprogramowania pomiędzy klientami.</span></p>`;

export default html;
